<template>
    <div class="patsnap-biz-list">
        <div
            v-if="$slots.prefix"
            class="patsnap-biz-list-prefix"
        >
            <slot name="prefix" />
        </div>
        <ul class="patsnap-ui-list">
            <template v-for="(item, index) in normalizeItems">
                <li
                    v-if="item && item.divider"
                    :key="`pt_list_${index}`"
                    :class="{
                        'patsnap-ui-list-divider': true,
                        'patsnap-ui-list-divider--with-icon': item.icon,
                        'patsnap-ui-list-divider--with-label': item.label,
                    }"
                >
                    <slot
                        name="divider"
                        :item="item"
                    >
                        <PtIcon
                            v-if="item.icon"
                            :icon="item.icon"
                            class="patsnap-ui-list-divider__icon"
                        />
                        <span
                            v-if="item.label"
                            class="patsnap-ui-list-divider__text"
                        >{{ item.label }}</span>
                        <hr>
                    </slot>
                </li>
                <li
                    v-else
                    :key="`pt_list_${index}`"
                    :class="{
                        active: item.active,
                        'patsnap-ui-list-item': true,
                        ...(item.classname ? {
                            [item.classname]: true,
                        }: {})
                    }"
                    v-on="item.$listeners || {}"
                    @click="handleItemClick(item)"
                >
                    <slot
                        v-if="getSlotName(item.label)"
                        :name="getSlotName(item.label)"
                    />
                    <slot
                        v-else
                        :item="item"
                    >
                        <PtIcon
                            v-if="item.icon"
                            :icon="item.icon"
                            class="patsnap-ui-list-item__pre-icon"
                        />
                        <a
                            v-if="item.href"
                            :href="item.href"
                            :target="calcTargetByItem(item)"
                            class="patsnap-ui-list-item__content"
                        >
                            <span>{{ item.label }}</span>
                        </a>
                        <span
                            v-else
                            class="patsnap-ui-list-item__content"
                        >{{ item.label }}</span>
                        <PtIcon
                            v-if="item.postIcon"
                            :icon="item.postIcon"
                            class="patsnap-ui-list-item__post-icon"
                        />
                    </slot>
                </li>
            </template>
        </ul>
        <div
            v-if="$slots.post"
            class="patsnap-biz-list-post"
        >
            <slot name="post" />
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import { ListService, getSlotName } from '@patsnap-utils/biz';

export default {
    name: 'PtList',
    components: {
        PtIcon,
    },
    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        normalizeItems() {
            return this.items.map(ListService.normalize);
        },
    },
    methods: {
        getSlotName,
        handleItemClick(item) {
            this.$emit('itemClick', item);
        },
        calcTargetByItem(item) {
            const target = '_blank';
            if (item.href && item.target) {
                return item.target || target;
            }
            return target;
        },
    },
};
</script>
